import { config } from "./config.js";

const verificationStorageKey = "syscofy-auth-verification";

function sameOriginTarget(value) {
	if (!value) return "";
	try {
		const target = new URL(value, location.origin);
		if (target.origin !== location.origin) return "";
		return `${target.pathname}${target.search}${target.hash}`;
	} catch (_error) {
		return "";
	}
}

function redirectAfterLogin(payload) {
	const requested = sameOriginTarget(config.redirectTo);
	const serverTarget = sameOriginTarget(payload.redirect_to || payload.home_page);
	location.assign(requested || serverTarget || "/desk");
}

function beginVerification(payload) {
	const tmpId = String(payload.tmp_id || "");
	if (!tmpId) return false;
	const secure = location.protocol === "https:" ? "; Secure" : "";
	document.cookie = `tmp_id=${encodeURIComponent(
		tmpId,
	)}; Path=/; Max-Age=300; SameSite=Lax${secure}`;
	try {
		sessionStorage.setItem(
			verificationStorageKey,
			JSON.stringify({ tmpId, verification: payload.verification || {} }),
		);
	} catch (_error) {
		// The tmp_id cookie is sufficient to continue when session storage is unavailable.
	}
	location.assign(config.routes?.verify || "/verify-login");
	return true;
}

export function handleLoginPayload(payload) {
	if (payload.verification && payload.message !== "Logged In") {
		return beginVerification(payload);
	}
	if (payload.message === "Password Reset" && sameOriginTarget(payload.redirect_to)) {
		location.assign(sameOriginTarget(payload.redirect_to));
		return true;
	}
	if (["Logged In", "No App"].includes(payload.message)) {
		clearVerificationState();
		redirectAfterLogin(payload);
		return true;
	}
	return false;
}

export function verificationState() {
	let stored = {};
	try {
		stored = JSON.parse(sessionStorage.getItem(verificationStorageKey) || "{}");
	} catch (_error) {
		stored = {};
	}
	const cookie = document.cookie.split("; ").find((entry) => entry.startsWith("tmp_id="));
	const cookieTmpId = cookie ? decodeURIComponent(cookie.slice("tmp_id=".length)) : "";
	return { ...stored, tmpId: stored.tmpId || cookieTmpId };
}

export function clearVerificationState() {
	try {
		sessionStorage.removeItem(verificationStorageKey);
	} catch (_error) {
		// Nothing else is required.
	}
	document.cookie = "tmp_id=; Path=/; Max-Age=0; SameSite=Lax";
}
